import useStyles from 'isomorphic-style-loader/useStyles';
import type { PropsWithChildren } from 'react';
import { createRef } from 'react';
import { createPortal } from 'react-dom';
import { useIsClient } from 'usehooks-ts';

import s from './side-nav-decoration.scss';

const sideNavDecorationRef = createRef<HTMLDivElement>();

export const SideNavDecorationContainer = () => {
  useStyles(s);

  return <div ref={sideNavDecorationRef} className={s.container} />;
};

export const SideNavDecoration = ({ children }: PropsWithChildren<unknown>) => {
  const isClient = useIsClient();

  if (!isClient || !sideNavDecorationRef.current) {
    return null;
  }

  return createPortal(children, sideNavDecorationRef.current);
};

export default SideNavDecoration;
